export default __webpack_public_path__ + "static/media/oracle_icon.49027dc8.svg";